import { ReactNode } from "react";
import { Box } from "@chakra-ui/react";
import { ANSEM_PARTNER } from "../../constants/partners";

interface ScratchWordProps {
  children: ReactNode;
  /** Strike-through stroke to stretch over the text, tinted per partner. */
  strokeUrl?: string;
}

// Word(s) crossed out with a hand-drawn scratch stroke. The SVG (served from
// /public, in the partner accent) is stretched over the text so it fits any word
// length. Shared by the partner heroes and the nav crossout.
export const ScratchWord = ({
  children,
  strokeUrl = ANSEM_PARTNER.scratchUrl,
}: ScratchWordProps) => (
  <Box as="span" position="relative" display="inline-block" whiteSpace="nowrap">
    {children}
    <Box
      as="span"
      aria-hidden
      position="absolute"
      left="-6%"
      right="-6%"
      top="50%"
      height="0.62em"
      transform="translateY(-45%)"
      backgroundImage={`url('${strokeUrl}')`}
      backgroundSize="100% 100%"
      backgroundRepeat="no-repeat"
      pointerEvents="none"
    />
  </Box>
);
